import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { VisibleOnly } from "@/components/utils/VisibleOnly";
import { StreamateCamera } from "@/components/ads/StreamateCamera";
import "./StreamateCameraModule.scss";

interface IStreamateCameraModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
  position: number;
}

export const StreamateCameraModule = ({ moduleId, moduleType, position }: IStreamateCameraModule) => {
  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <VisibleOnly className="GifPreview StreamateCameraDispatcher">
        <StreamateCamera position={position} />
      </VisibleOnly>
    </FeedModuleContainer>
  );
};
